
        
            <div class="content-wrapper">
                <div class="row">
                    <div class="col-xl-12 stretch-card grid-margin">
                        <div class="card card-white">
                            <div class="card-body p-4">
                                <div class="d-sm-flex  align-items-center">
                                    <img src="assets/images/dash.png" width="20%" alt="banner"
                                        class="mr-0 mr-sm-5 img-reaponsive">
                                    <div style="cursor: context-menu;">
                                        <h2 class="mt-0 mt-lg-3">ฝ่ายการเงินและบัญชี</h2>
                                        <p class="text-medium mb-0">
                                            ระบบฐานข้อมูลการติดตามโครงการที่ได้รับเงินสนับสนุนจากกองทุนจัดรูปที่ดินเพื่อพัฒนาพื้นที่
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex align-items-center justify-content-between" style="cursor: context-menu;">
                    <h4 class="mb-3">รายงานสถานะทางการเงิน ณ วันที่ {{financial_status.date}}</h4>
                </div>

                <div class="row" style="cursor: pointer;" [routerLink]="['/report/financialstatus']">
                    <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 grid-margin stretch-card">
                        <div class="row">
                            <div class="row col-12">
                                <div class="col-xl-6 col-sm-6 grid-margin stretch-card">
                                    <div class="card bg-gradient-danger card-img-holder text-white">
                                        <div class="card-body px-4 py-4">
                                            <img src="assets/images/dashboard/circle.svg" class="card-img-absolute"
                                                alt="circle-image">
                                            <h4 class="mb-3">บัญชีเงินฝากประจำ</h4>
                                            <h3 class="mb-2">{{financial_status.acc_fixed | number:'1.2-2'}}</h3>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-sm-6 grid-margin stretch-card">
                                    <div class="card bg-gradient-primary card-img-holder text-white">
                                        <div class="card-body px-4 py-4">
                                            <img src="assets/images/dashboard/circle.svg" class="card-img-absolute"
                                                alt="circle-image">
                                            <h4 class="mb-3">บัญชีเงินฝากออมทรัพย์</h4>
                                            <h3 class="mb-2">{{financial_status.acc_savings | number:'1.2-2'}}</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row col-12">
                                <div class="col-xl-6 col-sm-6 grid-margin stretch-card">
                                    <div class="card bg-gradient-info card-img-holder text-white">
                                        <div class="card-body px-4 py-4">
                                            <img src="assets/images/dashboard/circle.svg" class="card-img-absolute"
                                                alt="circle-image">
                                            <h4 class="mb-3">บัญชีเงินฝากกระแสรายวัน</h4>
                                            <h3 class="mb-2">{{financial_status.acc_current | number:'1.2-2'}}</h3>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-sm-6 grid-margin stretch-card">
                                    <div class="card bg-gradient-warning card-img-holder text-white">
                                        <div class="card-body px-4 py-4">
                                            <img src="assets/images/dashboard/circle.svg" class="card-img-absolute"
                                                alt="circle-image">
                                            <h4 class="mb-3">เงินฝากกระทรวงการคลัง</h4>
                                            <h3 class="mb-2">{{financial_status.acc_deposits | number:'1.2-2'}}</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 grid-margin stretch-card">
                        <div class="card bg-gradient-success card-img-holder text-white grid-margin stretch-card">
                            <img src="assets/images/dashboard/circle.svg" class="card-img-absolute" alt="circle-image">
                            <div class="v-center">
                                <h3 class="mb-4">รวมเงินฝากทั้งสิ้น</h3>
                                <h2 class="mb-2">{{financial_status.acc_sum | number:'1.2-2'}}</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12 grid-margin grid-margin stretch-card">
                        <div class="card">
                            <div class="card-body">
                                <h4 class="card-title" style="cursor:pointer;" [routerLink]="['/performancesummary']">สรุปผลการดำเนินงาน</h4>
                                <div>
                                    <div echarts [options]="options" class="demo-chart"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            